{
  "name": "@poe-code/markdown-reader",
  "version": "0.0.1",
  "private": true,
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    }
  },
  "scripts": {
    "build": "node ../../scripts/guard-package-dist.mjs && tsc",
    "test": "cd ../.. && vitest run packages/markdown-reader/src/*.test.ts packages/markdown-reader/src/**/*.test.ts --coverage.enabled --coverage.provider=v8 --coverage.reporter=text-summary --coverage.include='packages/markdown-reader/src/core/*.ts' --coverage.exclude='packages/markdown-reader/src/core/*.test.ts' --coverage.thresholds.lines=90",
    "test:unit": "cd ../.. && vitest run packages/markdown-reader/src/*.test.ts packages/markdown-reader/src/**/*.test.ts"
  },
  "files": [
    "dist"
  ],
  "dependencies": {
    "@poe-code/frontmatter": "*",
    "toolcraft": "*",
    "toolcraft-schema": "*",
    "toolcraft-design": "*"
  }
}
